import Link from "next/link";

import styles from "./AvailableGuides.module.css";
import AvailableGuidesCarousel, {
  AvailableGuidesCarouselProps,
} from "./AvailableGuidesCarousel";

export type AvailableGuidesProps = Pick<
  AvailableGuidesCarouselProps,
  "availableGuides" | "product"
>;

export function AvailableGuides({
  product,
  availableGuides,
}: AvailableGuidesProps) {
  return (
    <>
      <div className={styles.AvailableGuidesContainer}>
        <div className={styles.AvailableGuideList}>
          <AvailableGuidesCarousel
            title={"Assigned Guides for Upcoming Tours"}
            availableGuides={availableGuides}
            product={product}
          />
        </div>
        <Link
          href={`/checkout/${product.id}?ref=detail-guide-availability`}
          className="ui-Link"
          style={{ textAlign: "center", width: "100%", marginTop: 20 }}
        >
          SEE ALL AVAILABILITY
        </Link>
      </div>
    </>
  );
}
